import * as React from "react";

const tokenKey = "jwt";
const tokenExpiryKey = "jwtExpires";
const refreshTokenKey = "refreshToken";

export class JwtManager extends React.PureComponent {
  getToken(): string | null {
    return localStorage.getItem(tokenKey);
  }

  setToken(token: string) {
    localStorage.setItem(tokenKey, token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(refreshTokenKey);
  }

  setRefreshToken(refreshToken: string) {
    localStorage.setItem(refreshTokenKey, refreshToken);
  }

  getExpires(): Date | null {
    var expires = localStorage.getItem(tokenExpiryKey);
    if (!expires) return null;
    return new Date(Number(expires) * 1000);
  }

  setExpires(expires: any) {
    localStorage.setItem(tokenExpiryKey, expires);
  }

  storeAuthResponse(token: string, expires: number, refreshToken: string) {
    this.setToken(token);
    this.setExpires(expires);
    this.setRefreshToken(refreshToken);
  }

  removeToken(): void {
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(tokenExpiryKey);
    localStorage.removeItem(refreshTokenKey);
  }

  getPayload(): Record<string, string | string[] | undefined> | null {
    const token = this.getToken();

    if (token != null) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );

      return JSON.parse(jsonPayload);
    } else {
      return null;
    }
  }
}
